import { Injectable, inject } from '@angular/core';
import { GzToastService } from '@gozem/ui';

/**
 * Notification Service
 * Centralized service for displaying notifications across the app.
 * Delegates to GzToastService from @gozem/ui.
 *
 * Usage:
 * - success(): Green toast for successful operations
 * - error(): Red toast for errors
 * - warning(): Yellow toast for warnings
 * - info(): Blue toast for informational messages
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly toastService = inject(GzToastService);

  /**
   * Display success notification
   */
  success(message: string, title = 'Succès'): void {
    this.toastService.success(message, title);
  }

  /**
   * Display error notification
   */
  error(message: string, title = 'Erreur'): void {
    this.toastService.error(message, title);
  }

  /**
   * Display warning notification
   */
  warning(message: string, title = 'Attention'): void {
    this.toastService.warning(message, title);
  }

  /**
   * Display info notification
   */
  info(message: string, title = 'Information'): void {
    this.toastService.info(message, title);
  }

  /**
   * Dismiss all active notifications
   */
  clear(): void {
    this.toastService.dismissAll();
  }
}
